import { render, staticRenderFns } from "./InventoryAutoConfig.vue?vue&type=template&id=3e8e4882&scoped=true&"
import script from "./InventoryAutoConfig.vue?vue&type=script&lang=js&"
export * from "./InventoryAutoConfig.vue?vue&type=script&lang=js&"
import style0 from "./InventoryAutoConfig.vue?vue&type=style&index=0&id=3e8e4882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8e4882",
  null
  
)

export default component.exports